import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function NoVideoIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.8 3.8A1.8 1.8 0 0 0 2 5.6v4.8a1.8 1.8 0 0 0 1.8 1.8h5.4a1.8 1.8 0 0 0 1.722-1.275M11 8l2.18-2.18c.258-.258.386-.386.497-.395a.3.3 0 0 1 .251.104c.072.085.072.266.072.63V9.84c0 .364 0 .545-.072.63a.3.3 0 0 1-.252.104c-.11-.009-.238-.137-.495-.394zm0 0V6.68c0-1.008 0-1.512-.196-1.897a1.8 1.8 0 0 0-.787-.787C9.632 3.8 9.128 3.8 8.12 3.8H6.5M2 2l12 12" /></svg>
  );
}

export default NoVideoIcon;
